import { filesize } from 'filesize';

import { getPropertyValue } from 'types/node';

import { DisplayerProps } from '../controls/input';

export function FileSizeDisplayer({ node, property, value }: DisplayerProps) {
  const resolvedValue = value ?? getPropertyValue(node.data, property);

  return <strong>{filesize(Number(resolvedValue), { base: 2 })}</strong>;
}
